export default "__VITE_ASSET__5194d456__"